import { el } from './ui'

// A pop-up's main button pinned to its foot (Liam, 26 Oct 2026: "button is not sticky which should be standard throught
// the app and maybe even desktop"): it stays in sight however long the pop-up is, on a phone and a computer. A <footer>,
// so sheet-keyboard.ts keeps a box being typed in clear of it. Buttons that act on one row (a visit's Cash and Bank, a
// day tile) stay beside what they act on.
export function pinFoot(...nodes: (Node | null | undefined | false)[]): HTMLElement {
  return el('footer', { class: 'pin-foot' }, ...nodes.filter((n): n is Node => !!n))
}
